<template>
    <div class="">
        <v-dialog v-model="dialog" width="500">
            <v-card :loading="loader">
                <v-card-title class="text-h7 grey lighten-2">
                    عکس های آپلود شده
                </v-card-title>
                <!-- <div style="min-height:300px;overflow-y:scroll"></div> -->
                <v-card-text>
                    <v-row>
                        <v-col v-for="(item , i) in images" :key="i" class="d-flex child-flex" cols="3">
                            <v-img @click="setImageUrl(item.url)" :src="$BaseUrl+item.url" :lazy-src="$BaseUrl+item.url" aspect-ratio="1"
                                class="test grey lighten-2">
                                <template v-slot:placeholder>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                    </v-row>
                                </template>
                            </v-img>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-file-input class="d-none file-input" id="fileImage" @change="uploadImg" v-model="imgPath"
                        prepend-icon=''>
                    </v-file-input>
                    <v-btn text @click="selectFileInput">
                        آپلود عکس جدید
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                dialog: false,
                imgPath: '',
                loader: false,
                images: [],
                image: '',
            }
        },
        methods: {
            uploadImg() {
                this.loader = true
                var formData = new FormData()
                formData.append('file', this.imgPath)
                this.request({
                        method: 'post',
                        url: '/admin/upload',
                        data: formData
                    })
                    .then((response) => {
                        this.image = response.url
                        this.$emit('uploadDone', this.image)
                        this.images.push({
                            name : 'new image', 
                            url: response.url
                        })
                        this.dialog = false
                    })
                    .catch(error => {})
                    .finally(x => {
                        this.loader = false
                    })
            },
            selectFileInput() {
                document.getElementById('fileImage').click();
            },
            getFiles() {
                this.loader = true
                this.request({
                        method: 'get',
                        url: '/admin/Files',
                    })
                    .then((response) => {
                        this.images = response
                    })
                    .catch(error => {})
                    .finally(x => {
                        this.loader = false
                    })

            },
            setImageUrl(image){
                this.$emit('uploadDone', image)
                // this.$emit('setImgUrl' , image)
                this.dialog = false
            }
        },
        mounted(){
        },
        created() {
            this.getFiles()
        }
    }
</script>

<style scoped>
.imageDialig{
    cursor: pointer !important;
    background-size: 100% !important;
    background-color: white !important;
}

</style>